import { render, staticRenderFns } from "./AddItemData.vue?vue&type=template&id=64414ee4&scoped=true&"
import script from "./AddItemData.vue?vue&type=script&lang=js&"
export * from "./AddItemData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64414ee4",
  null
  
)

export default component.exports